// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Scheduler, SchedulerDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateScheduler(): (
  requestBody: SchedulerDaten
) => Promise<Scheduler> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).schedulers.createScheduler({ requestBody }),
    [getAPI]
  );
}
